(function($) {
  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Main Script
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/
  $(function() {
    /* ----------------------------------------------------------------
    Global Variable declarations
    -----------------------------------------------------------------*/
    // Setting Up Global Variables to be used in JS - Denotes which template is which so JavaScript is used only on proper templates
    var BODY = $('body');

    /* ----------------------------------------------------------------
    Navigation
    -----------------------------------------------------------------*/
    // Mobile Navigation
    var mmStatus = 'closed';

    function closeMM() {
      mmStatus = 'closed';
      $('#mobile-navigation-toggle').toggleClass('opened');
      $('body').removeClass('nav-opened');
    }

    function openMM() {
      mmStatus = 'opened';
      $('body').addClass('nav-opened');
      $('#mobile-navigation-toggle').toggleClass('opened');
    }

    $('#mobile-navigation-toggle').on('click', function() {
      if (mmStatus == 'closed') {
        openMM();
      } else if (mmStatus == 'opened') {
        closeMM();
      }
      return false;
    });

    $('.mobile-dropdown-toggle').on('click', function() {
      $(this).toggleClass('fa-plus fa-minus');
      $(this).next().toggle();
    });

    function showDD() {
      $('.navigation-li').removeClass('hovered');
      $(this).toggleClass('hovered');
    }

    function hideDD() {
      $(this).removeClass('hovered');
    }
    /* main navigation */
    $(".navigation-li").hoverIntent({
      over: showDD,
      out: hideDD,
      timeout: 350
    });

    $('.faq-title').on('click', function(){
      $(this).next().toggleClass('faq-copy--active');
      if($(this).next().hasClass('faq-copy--active')) {
        $('.toggle', this).html('&mdash;');
      } else {
        $('.toggle', this).html('+');
      };
    });


    $('.faq-article-wrapper h2').on('click', function(){
      $(this).next().toggleClass('faq-content--active');
      if($(this).next().hasClass('faq-content--active')) {
        $('.toggle', this).html('&mdash;');
      } else {
        $('.toggle', this).html('+');
      };
    });
    
    $('.header-features a').first().addClass('feature-active');
    setInterval(function(){
      var active = $(".feature-active").removeClass('feature-active');
      // console.log(active.siblings('.feature'));
      if(active.next() && active.next().length){
        active.siblings().eq(active.index()+1).addClass('feature-active');
      }
      else{
        active.siblings(":first").addClass('feature-active');
      }
    }, 3000);

    /* ----------------------------------------------------------------
    jQuery toggles
    -----------------------------------------------------------------*/
    //Press Section
    $('.press-view-more').on('click', function(e) {
      e.preventDefault();
      $(this).prev().toggle();
      if ($(this).hasClass('view-more')) {
        $(this).toggleClass('view-more', 'view-less').html('<i class="fa fa-minus-square" aria-hidden="true"></i> View Less');
      } else {
        $(this).toggleClass('view-more', 'view-less').html('<i class="fa fa-plus-square" aria-hidden="true"></i> View More');
      }
    });

    //Login Page - forgot password toggle
    $('#forgot-password').on('click', function() {
      $('#recover-password-form').show();
      $('#customer-login-form').hide();
    });

    $('#forgot-password-cancel').on('click', function() {
      $('#recover-password-form').hide();
      $('#customer-login-form').show();
    });

    //Article share toggle
    $('#article-share-link').on('click', function(e) {
      e.preventDefault();
      $(this)
        .next()
        .toggle();
      if ($(this).text() == '+ Share') {
        $(this).text('- Share');
      } else {
        $(this).text('+ Share');
      }
    });

  });
})(jQuery);
